import { animatedScroll, throttle } from "../../lib";

export default class MobileNavModule {
	constructor($trigger) {
		this.$root = document.querySelector('.mobile-nav-menu');
		this.$header = this.$root.querySelector('.mobile-nav-menu_header');
		this.$sectionsContainer = document.getElementById('mobileNavMenuSections');
		this.$sectionList = this.$root.querySelectorAll('.mobile-nav-menu_section');
		this.$trigger = $trigger;
		this.$closeBtn = document.getElementById('mobile-nav-close');
		this.$collapseItemCollection = this.$root.querySelectorAll('.mobile-nav-menu_item.-collapse');
		this.$goBackBtn = document.getElementById('mobileNavMenuBack');

		this.windowHeight = null;

		this.init();
	}

	init() {
		this.addListeners();
	}

	addListeners() {
		this.openingListener();
		this.closingListener();
		this.goBackListener();
		this.itemCollapsingListener();
		this.appleToolbarListener();
	}

	appleToolbarListener() {
		window.addEventListener('load', () => {
			this.setHeight();
		});
		window.addEventListener('resize', throttle(() => {
			this.setHeight();
		}, 50))
	}

	setHeight() {
		this.windowHeight = window.innerHeight;
		this.$sectionsContainer.style.height = this.windowHeight + 'px';
		this.$sectionList.forEach(($section) => {
			$section.style.height = this.windowHeight + 'px';
		});
	}

	openingListener() {
		this.$trigger.addEventListener('click', () => {
			if (!this.$root.classList.contains('-opened')) {
				this.$root.classList.add('-opened');
				document.body.classList.add('-mobile-nav-opened');
				scrollLock.disablePageScroll(this.$sectionList);
			}
		});
	}

	closingListener() {
		this.$closeBtn.addEventListener('click', () => {
			if (this.$root.classList.contains('-opened')) {
				this.$root.classList.remove('-opened');
				document.body.classList.remove('-mobile-nav-opened');
				this.setActiveSection('main');
				scrollLock.enablePageScroll();
			}
		});
	}

	itemCollapsingListener() {
		this.$collapseItemCollection.forEach($item => {
			const $trigger = $item.querySelector('.card_header');
			const $collapse = $item.querySelector('.card_collapse');
			const $body = $item.querySelector('.card_body');



			$trigger.addEventListener('click', () => {
				if (!$item.classList.contains('-collapsed')) {
					const bodyHeight = $body.offsetHeight;

					$item.classList.add('-collapsed');
					$collapse.style.maxHeight = bodyHeight + 'px';

					if ($item.classList.contains('-cities')) {
						animatedScroll(this.$root, bodyHeight);
					}
				} else {
					$item.classList.remove('-collapsed');
					$collapse.style.maxHeight = null;
				}
			});
		});
	}

	goBackListener() {
		this.$goBackBtn.addEventListener('click', this.goBack.bind(this));
	}

	setActiveSection(name) {
		if (name !== 'main' && name !== 'courses-menu' && name !== 'courses-nav') {
			return
		}

		this.$sectionsContainer.dataset.active = name;

		if (name === 'main') {
			this.$header.classList.remove('-back');
		}
	}

	goBack() {
		const currentActiveSection = this.$sectionsContainer.dataset.active;

		switch (currentActiveSection) {
			case 'courses-nav':
				this.setActiveSection('courses-menu');
				break;
			default:
				this.setActiveSection('main');
				break;
		}
	}
}